function fmtMoney(cents, currency) {
  try {
    return new Intl.NumberFormat(undefined, { style: 'currency', currency }).format(cents / 100);
  } catch (e) {
    return (cents / 100).toFixed(2) + ' ' + currency;
  }
}

function computeUnitCents(baseCents, qty, discounts) {
  // For packs with no explicit discount entry, use the 10-pack discount as the baseline
  // so that 50/120/240-packs are priced per-unit the same as the 10-pack
  let key = String(qty);
  let d;
  if (discounts[key] !== undefined) {
    d = Number(discounts[key]);
  } else if (qty >= 10 && discounts['10'] !== undefined) {
    d = Number(discounts['10']);
  } else {
    d = 0;
  }
  const unit = Math.round(baseCents * (1 - d));
  return unit;
}

function updateCard(card) {
  const baseCents = Number(card.dataset.basePriceCents || 0);
  const currency = card.dataset.currency || 'EUR';
  const discounts = card.dataset.discounts ? JSON.parse(card.dataset.discounts) : {};
  const select = card.querySelector('[data-pack-select]');
  const triggerTotal = card.querySelector('[data-pack-trigger-total]');
  const triggerUnit = card.querySelector('[data-pack-trigger-unit]');
  const trigger = card.querySelector('[data-pack-trigger]');
  const form = card.closest('form[action*="/cart/add"]') || card.closest('form');
  const realQty = form ? form.querySelector('[data-real-qty]') : null;

  if (!baseCents || !select) return;

  const qty = Number(select.value || card.dataset.defaultPack || 10);
  const unitCents = computeUnitCents(baseCents, qty, discounts);
  const totalCents = unitCents * qty;

  // Resolve inventory constraints
  const inventoryRaw = card.dataset.inventory;
  const inventoryPolicy = card.dataset.inventoryPolicy || 'deny';
  const inventory = (inventoryRaw !== undefined && inventoryRaw !== '') ? Number(inventoryRaw) : Infinity;
  const stockLimited = inventoryPolicy === 'deny' && isFinite(inventory);

  if (triggerTotal) {
    triggerTotal.textContent = `${qty}-pack - ${fmtMoney(totalCents, currency)}`;
  }
  if (triggerUnit) {
    triggerUnit.textContent = `${fmtMoney(unitCents, currency)} pr can`;
  }

  // Mark trigger as unavailable when selected pack exceeds stock
  if (trigger) {
    trigger.classList.toggle('is-unavailable', stockLimited && inventory < qty);
  }

  card.querySelectorAll('[data-pack-option]').forEach(option => {
    const optQty = Number(option.dataset.packValue);
    const optUnitCents = computeUnitCents(baseCents, optQty, discounts);
    const optTotalCents = optUnitCents * optQty;
    const priceEl = option.querySelector(`[data-option-price="${optQty}"]`);
    const unitEl = option.querySelector(`[data-option-unit="${optQty}"]`);
    if (priceEl) {
      priceEl.textContent = fmtMoney(optTotalCents, currency);
    }
    if (unitEl) {
      unitEl.textContent = `(${fmtMoney(optUnitCents, currency)} pr can)`;
    }

    if (optQty === qty) {
      option.classList.add('is-selected');
    } else {
      option.classList.remove('is-selected');
    }

    // Line out options that exceed available stock
    option.classList.toggle('is-unavailable', stockLimited && inventory < optQty);
  });

  if (realQty) realQty.value = String(qty);
}

function initPackUI(card) {
  console.log('initPackUI called for:', card);
  
  const select = card.querySelector('[data-pack-select]');
  const trigger = card.querySelector('[data-pack-trigger]');
  const options = card.querySelectorAll('[data-pack-option]');
  
  console.log('Elements found:', { select, trigger, options: options.length });
  
  if (!select || !trigger) {
    console.warn('Missing select or trigger!');
    return;
  }

  if (card.dataset.initialized) {
    console.log('Already initialized, skipping');
    return;
  }
  card.dataset.initialized = 'true';

  const def = Number(card.dataset.defaultPack || 10);
  if ([...select.options].some(o => Number(o.value) === def)) {
    select.value = String(def);
  }

  function closeDropdown() {
    console.log('Closing dropdown');
    card.classList.remove('is-open');
  }

  function openDropdown() {
    console.log('Opening dropdown');
    document.querySelectorAll('.pack-ui.is-open').forEach(otherCard => {
      if (otherCard !== card) {
        otherCard.classList.remove('is-open');
      }
    });
    card.classList.add('is-open');
  }

  trigger.addEventListener('click', function(e) {
    console.log('Trigger clicked!', e);
    e.preventDefault();
    e.stopPropagation();
    
    const isOpen = card.classList.contains('is-open');
    console.log('Is open?', isOpen);
    
    if (isOpen) {
      closeDropdown();
    } else {
      openDropdown();
    }
  }, true); // Use capture phase

  options.forEach(option => {
    option.addEventListener('click', function(e) {
      if (this.classList.contains('is-unavailable')) return;
      console.log('Option clicked:', this.dataset.packValue);
      e.stopPropagation();
      const value = this.dataset.packValue;
      select.value = value;
      updateCard(card);
      closeDropdown();
    });
  });

  console.log('Pack UI initialized successfully');
  updateCard(card);
}

function initAllPackUI() {
  console.log('initAllPackUI called');
  const allPackUIs = document.querySelectorAll('[data-pack-ui]');
  console.log('Found total pack-ui elements:', allPackUIs.length);
  allPackUIs.forEach(function(packUI) {
    console.log('Initializing pack-ui element:', packUI);
    initPackUI(packUI);
  });
}

// Eksporter til window
window.initPackUI = initPackUI;
window.initAllPackUI = initAllPackUI;

console.log('pack-selector.js loaded!');

// Auto-init på load
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', function() {
    console.log('DOMContentLoaded - running initAllPackUI');
    initAllPackUI();
  });
} else {
  console.log('Document already ready - running initAllPackUI');
  initAllPackUI();
}

// Re-init på section load
document.addEventListener('shopify:section:load', initAllPackUI);

// Luk dropdown når man klikker udenfor
document.addEventListener('click', function(e) {
  if (!e.target.closest('.pack-ui')) {
    document.querySelectorAll('.pack-ui.is-open').forEach(function(card) {
      card.classList.remove('is-open');
    });
  }
});

// ============================================
// PACK SELECTOR TABLE FUNCTIONALITY
// ============================================

class PackSelectorTable {
  constructor(container) {
    this.container = container;
    this.buttons = container.querySelectorAll('.pack-selector__add-button');
    this.init();
  }

  init() {
    this.buttons.forEach(button => {
      button.addEventListener('click', (e) => this.handleAddToCart(e));
    });
  }

  async handleAddToCart(event) {
    const button = event.target;
    const quantity = parseInt(button.dataset.quantity);
    const variantId = button.dataset.variantId;
    
    if (!variantId || !quantity) {
      console.error('Missing variant ID or quantity');
      return;
    }

    // Disable button and show loading state
    button.disabled = true;
    const originalText = button.textContent;
    button.textContent = 'Tilføjer...';

    try {
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({
          items: [{
            id: variantId,
            quantity: quantity
          }]
        })
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.description || errorData.message || 'Failed to add to cart');
      }

      const data = await response.json();
      
      // Success feedback
      button.textContent = '✓ Tilføjet';
      button.classList.add('pack-selector__add-button--success');
      
      // Update cart (trigger cart drawer/notification if available)
      this.updateCart();
      
      // Reset button after 2 seconds
      setTimeout(() => {
        button.textContent = originalText;
        button.disabled = false;
        button.classList.remove('pack-selector__add-button--success');
      }, 2000);

    } catch (error) {
      console.error('Error adding to cart:', error);
      button.textContent = error.message || 'Fejl - Prøv igen';
      button.classList.add('pack-selector__add-button--error');
      
      setTimeout(() => {
        button.textContent = originalText;
        button.disabled = false;
        button.classList.remove('pack-selector__add-button--error');
      }, 2000);
    }
  }

  updateCart() {
    // Trigger cart update events
    fetch('/cart.js')
      .then(response => response.json())
      .then(cart => {
        // Publish cart update event
        document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
          bubbles: true,
          detail: { cart }
        }));

        // Try to open cart drawer if it exists
        const cartDrawer = document.querySelector('cart-drawer');
        const cartNotification = document.querySelector('cart-notification');
        
        if (cartDrawer && typeof cartDrawer.open === 'function') {
          cartDrawer.open();
        } else if (cartNotification && typeof cartNotification.open === 'function') {
          cartNotification.open();
        }
      })
      .catch(error => console.error('Error updating cart:', error));
  }
}

// Initialize all pack selector tables
function initPackSelectorTables() {
  const containers = document.querySelectorAll('.pack-selector');
  containers.forEach(container => {
    if (!container.dataset.packSelectorInitialized) {
      new PackSelectorTable(container);
      container.dataset.packSelectorInitialized = 'true';
    }
  });
}

// Auto-init
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initPackSelectorTables);
} else {
  initPackSelectorTables();
}

// Re-init on Shopify section events
document.addEventListener('shopify:section:load', initPackSelectorTables);
document.addEventListener('shopify:section:reorder', initPackSelectorTables);
